const pillarPages = [
  {
    slug: 'scrittura-creativa',
    path: '/scrittura-creativa/',
    title: 'Scrittura creativa: tecniche, strumenti e scelte narrative',
    seoTitle: 'Scrittura creativa: tecniche e strumenti | Verso Hemelslinn',
    description:
      'Tecniche di scrittura creativa per costruire scene, descrizioni, dialoghi e punti di vista attraverso esempi narrativi e scelte concrete.',
    intro:
      'Scrivere una storia non significa soltanto avere una buona idea. Significa scegliere chi osserva gli eventi, quali dettagli mostrare, quanto tempo dedicare a una scena e quando permettere al lettore di comprendere ciò che sta accadendo.',
    sections: [
      {
        title: 'Il punto di vista',
        text:
          'Il punto di vista stabilisce attraverso quali occhi il lettore entra nella storia. Decide quali informazioni sono disponibili, quali emozioni possono essere percepite e quali aspetti della scena rimangono nascosti.',
        roadmap: [
          {
            title: 'Descrivere attraverso il punto di vista',
            completed: true,
            articleTitle: 'Non descrivere il mondo: mostra chi lo sta guardando',
            href: '/articoli/non-descrivere-il-mondo-mostra-chi-lo-sta-guardando/',
          },
          'Prima persona o terza persona: come scegliere',
          'Che cosa può sapere il narratore',
          {
            title: 'Cambiare punto di vista senza confondere il lettore',
            completed: true,
            articleTitle: 'Cambiare punto di vista senza confondere il lettore',
            href: '/articoli/cambiare-punto-di-vista-senza-confondere-il-lettore/',
          },
        ],
      },
      {
        title: 'La descrizione narrativa',
        text:
          'Una descrizione efficace non registra ogni dettaglio. Sceglie quelli che hanno un significato per il personaggio, per l’atmosfera o per lo sviluppo della storia.',
        roadmap: [
          {
            title: 'Come descrivere un ambiente senza fermare la storia',
            completed: true,
            articleTitle: 'L’ambiente non deve aspettare che la storia si fermi',
            href: '/articoli/come-descrivere-un-ambiente-senza-fermare-la-storia/',
          },
          'Mostrare un mondo attraverso i dettagli',
          'Descrizione oggettiva e descrizione emotiva',
          'Quando una descrizione diventa troppo lunga',
        ],
      },
      {
        title: 'Ritmo e costruzione della scena',
        text:
          'Il ritmo dipende dalla quantità di informazioni, dall’alternanza tra azione e riflessione e dal punto in cui una scena viene interrotta.',
        roadmap: [
          {
            title: 'Scene d’azione chiare e coinvolgenti',
            completed: true,
            articleTitle: 'Il caos deve colpire i personaggi, non il lettore',
            href: '/articoli/come-scrivere-scene-azione-chiare-coinvolgenti/',
          },
          'Come costruire una scena narrativa',
          'Accelerare e rallentare il ritmo',
          'Dove iniziare e terminare una scena',
          'Azione, riflessione e conseguenze',
        ],
      },
    ],
    articleSlugs: [
      'informazioni-necessarie-dettagli-superflui-worldbuilding',
      'come-descrivere-un-ambiente-senza-fermare-la-storia',
      'una-tecnologia-non-e-credibile-perche-la-spieghi-bene',
      'come-scrivere-scene-azione-chiare-coinvolgenti',
      'dialogo-sottotesto-scrivere-cio-che-non-si-dice',
      'cambiare-punto-di-vista-senza-confondere-il-lettore',
      'non-descrivere-il-mondo-mostra-chi-lo-sta-guardando',
      'quando-i-personaggi-si-ribellano-alla-storia',
      'amore-non-e-una-pausa-dall-avventura',
    ],
    related: ['personaggi', 'worldbuilding', 'relazioni-nella-fantascienza', 'produzione-libri-ebook'],
  },
  {
    slug: 'personaggi',
    path: '/personaggi/',
    title: 'Creare personaggi credibili: desideri, conflitti e trasformazioni',
    seoTitle: 'Creare personaggi credibili | Verso Hemelslinn',
    description:
      'Come creare personaggi credibili attraverso desideri, conflitti, relazioni, punti di vista e trasformazioni nel corso della storia.',
    intro:
      'Un personaggio diventa credibile quando desidera qualcosa, teme di perderla e deve compiere scelte che hanno conseguenze. Il lettore deve percepirne motivazioni, contraddizioni e trasformazioni.',
    sections: [
      {
        title: 'Desiderio e bisogno',
        text:
          'Un personaggio può sapere che cosa vuole senza comprendere ciò di cui ha realmente bisogno. La distanza tra desiderio e bisogno crea movimento narrativo.',
        roadmap: [
          {
            title: 'Che cosa vuole davvero un personaggio',
            completed: true,
            articleTitle: 'Quando i personaggi si ribellano alla storia; L’amore non è una pausa dall’avventura',
            href: '/articoli/quando-i-personaggi-si-ribellano-alla-storia/',
          },
          {
            title: 'Obiettivo esterno e bisogno interiore',
            completed: true,
            articleTitle: 'Quando i personaggi si ribellano alla storia; L’amore non è una pausa dall’avventura',
            href: '/articoli/quando-i-personaggi-si-ribellano-alla-storia/',
          },
          {
            title: 'Motivazioni credibili e decisioni narrative',
            completed: true,
            articleTitle: 'Quando i personaggi si ribellano alla storia; in parte anche Il caos deve colpire i personaggi, non il lettore',
            href: '/articoli/quando-i-personaggi-si-ribellano-alla-storia/',
          },
          'Quando un personaggio sembra passivo',
        ],
      },
      {
        title: 'Conflitto interiore',
        text:
          'Il conflitto più interessante può nascere da due desideri incompatibili. Una scelta significativa elimina le soluzioni facili e comporta sempre una perdita.',
        roadmap: [
          'Come costruire un conflitto interiore',
          {
            title: 'Scelte difficili e conseguenze',
            completed: true,
            articleTitle: 'Quando i personaggi si ribellano alla storia; L’amore non è una pausa dall’avventura',
            href: '/articoli/quando-i-personaggi-si-ribellano-alla-storia/',
          },
          {
            title: 'Evitare conflitti artificiali tra i personaggi',
            completed: true,
            articleTitle: 'Quando le parole non bastano: dialogo, omissioni e sottotesto; anche L’amore non è una pausa dall’avventura',
            href: '/articoli/dialogo-sottotesto-scrivere-cio-che-non-si-dice/',
          },
          {
            title: 'Quando due desideri sono incompatibili',
            completed: true,
            articleTitle: 'Soprattutto L’amore non è una pausa dall’avventura',
            href: '/articoli/amore-non-e-una-pausa-dall-avventura/',
          },
        ],
      },
      {
        title: 'Voce e punto di vista',
        text:
          'Ogni personaggio osserva il mondo in modo personale. La voce si manifesta nei pensieri, nelle descrizioni e nelle associazioni che guidano il punto di vista.',
        roadmap: [
          'Come dare una voce riconoscibile a un personaggio',
          {
            title: 'Descrivere attraverso ciò che il personaggio nota',
            completed: true,
            articleTitle: 'Non descrivere il mondo: mostra chi lo sta guardando',
            href: '/articoli/non-descrivere-il-mondo-mostra-chi-lo-sta-guardando/',
          },
          {
            title: 'Pensieri, percezioni e distanza narrativa',
            completed: true,
            articleTitle: 'Non descrivere il mondo: mostra chi lo sta guardando',
            href: '/articoli/non-descrivere-il-mondo-mostra-chi-lo-sta-guardando/',
          },
          'Personaggi diversi che parlano nello stesso modo',
        ],
      },
    ],
    articleSlugs: [
      'come-scrivere-scene-azione-chiare-coinvolgenti',
      'dialogo-sottotesto-scrivere-cio-che-non-si-dice',
      'quando-i-personaggi-si-ribellano-alla-storia',
      'non-descrivere-il-mondo-mostra-chi-lo-sta-guardando',
      'amore-non-e-una-pausa-dall-avventura',
    ],
    related: ['scrittura-creativa', 'relazioni-nella-fantascienza', 'worldbuilding', 'produzione-libri-ebook'],
  },
  {
    slug: 'worldbuilding',
    path: '/worldbuilding/',
    title: 'Worldbuilding: costruire mondi narrativi credibili',
    seoTitle: 'Worldbuilding: costruire mondi credibili | Verso Hemelslinn',
    description:
      'Come progettare mondi narrativi credibili attraverso società, tecnologie, ambienti, storia e dettagli integrati nella narrazione.',
    intro:
      'Il worldbuilding non significa soltanto inventare nomi, tecnologie e mappe. Significa capire come le persone vivono dentro un mondo e quali conseguenze producono le sue regole.',
    sections: [
      {
        title: 'Il mondo esiste attraverso i personaggi',
        text:
          'Il lettore incontra l’ambientazione attraverso persone che la considerano parte della propria vita quotidiana. Il mondo diventa esperienza, non spiegazione.',
        roadmap: [
          {
            title: 'Che cos’è il worldbuilding',
            completed: true,
            articleTitle: 'Che cos’è il worldbuilding: costruire un mondo senza fermare la storia',
            href: '/articoli/che-cose-il-worldbuilding/',
          },
          {
            title: 'Mostrare il mondo attraverso i personaggi',
            completed: true,
            articleTitle: 'Non descrivere il mondo: mostra chi lo sta guardando',
            href: '/articoli/non-descrivere-il-mondo-mostra-chi-lo-sta-guardando/',
          },
          {
            title: 'Informazioni necessarie e dettagli superflui',
            completed: true,
            articleTitle: 'Il lettore non deve sapere tutto del tuo mondo',
            href: '/articoli/informazioni-necessarie-dettagli-superflui-worldbuilding/',
          },
          'Evitare l’enciclopedia dentro il romanzo',
        ],
      },
      {
        title: 'Tecnologia e conseguenze',
        text:
          'Una tecnologia dovrebbe modificare il comportamento delle persone e l’organizzazione della società. La domanda utile è: che cosa cambia perché questa tecnologia esiste?',
        roadmap: [
          {
            title: 'Come inventare tecnologie credibili',
            completed: true,
            articleTitle: 'Una tecnologia non è credibile perché la spieghi bene',
            href: '/articoli/una-tecnologia-non-e-credibile-perche-la-spieghi-bene/',
          },
          'Le conseguenze sociali di una tecnologia',
          'Quanto spiegare la scienza in un romanzo',
          'Tecnologia come strumento narrativo',
        ],
      },
      {
        title: 'Ambienti e luoghi',
        text:
          'Un luogo non è soltanto uno sfondo: condiziona movimenti, comportamenti ed emozioni. L’ambiente dovrebbe avere conseguenze concrete.',
        roadmap: [
          {
            title: 'Come descrivere un’astronave',
            completed: true,
            articleTitle: 'Come descrivere un’astronave: il worldbuilding non è un catalogo tecnico',
            href: '/articoli/come-descrivere-unastronave-worldbuilding/',
          },
          'Progettare città e colonie del futuro',
          'Ambiente, atmosfera e percezione',
          'Quando un luogo diventa parte del conflitto',
        ],
      },
    ],
    articleSlugs: [
      'informazioni-necessarie-dettagli-superflui-worldbuilding',
      'come-descrivere-un-ambiente-senza-fermare-la-storia',
      'come-descrivere-unastronave-worldbuilding',
      'una-tecnologia-non-e-credibile-perche-la-spieghi-bene',
      'che-cose-il-worldbuilding',
      'non-descrivere-il-mondo-mostra-chi-lo-sta-guardando',
    ],
    related: ['scrittura-creativa', 'personaggi', 'relazioni-nella-fantascienza', 'produzione-libri-ebook'],
  },
  {
    slug: 'relazioni-nella-fantascienza',
    path: '/relazioni-nella-fantascienza/',
    title: 'Scrivere relazioni nella fantascienza',
    seoTitle: 'Relazioni e amore nella fantascienza | Verso Hemelslinn',
    description:
      'Come scrivere relazioni, sentimenti e storie d’amore nella fantascienza integrandoli con trama, tecnologia, distanza e conflitto.',
    intro:
      'Una relazione ambientata nel futuro non smette di essere umana. Cambiano distanze, mezzi di comunicazione e contesto sociale, ma restano desiderio, paura, promessa e scelta.',
    sections: [
      {
        title: 'La relazione deve appartenere alla storia',
        text:
          'Una relazione romantica dovrebbe modificare le decisioni dei personaggi e, attraverso quelle decisioni, influenzare gli eventi.',
        roadmap: [
          {
            title: 'Come integrare una storia d’amore nella fantascienza',
            completed: true,
            articleTitle: 'L’amore non è una pausa dall’avventura',
            href: '/articoli/amore-non-e-una-pausa-dall-avventura/',
          },
          {
            title: 'Quando la relazione influenza la trama',
            completed: true,
            articleTitle: 'L’amore non è una pausa dall’avventura',
            href: '/articoli/amore-non-e-una-pausa-dall-avventura/',
          },
          'Romance e fantascienza: equilibrio tra i generi',
          'Evitare una sottotrama romantica artificiale',
        ],
      },
      {
        title: 'Distanza e separazione',
        text:
          'La distanza è uno dei temi naturali della fantascienza spaziale. Non dovrebbe essere solo un ostacolo logistico, ma trasformare il rapporto.',
        roadmap: [
          'Scrivere una relazione a distanza nello spazio',
          'Tempo, attesa e separazione',
          'Messaggi, silenzi e comunicazioni interrotte',
          'Il ritorno dopo una lunga assenza',
        ],
      },
      {
        title: 'Sentimento e conflitto',
        text:
          'Il conflitto romantico può nascere da valori differenti, responsabilità incompatibili o obiettivi che conducono in direzioni opposte.',
        roadmap: [
          {
            title: 'Dialogo e sottotesto tra persone che non possono dire tutto',
            completed: true,
            articleTitle: 'Quando le parole non bastano: dialogo e sottotesto tra persone che non possono dire tutto',
            href: '/articoli/dialogo-sottotesto-scrivere-cio-che-non-si-dice/',
          },
          'Creare un conflitto romantico credibile',
          'Amore e responsabilità incompatibili',
          'Evitare i malintesi costruiti artificialmente',
          'Quando nessuna scelta è indolore',
        ],
      },
    ],
    articleSlugs: [
      'dialogo-sottotesto-scrivere-cio-che-non-si-dice',
      'amore-non-e-una-pausa-dall-avventura',
    ],
    related: ['personaggi', 'scrittura-creativa', 'worldbuilding', 'produzione-libri-ebook'],
  },
  {
    slug: 'produzione-libri-ebook',
    path: '/produzione-libri-ebook/',
    title: 'Produzione di libri cartacei ed ebook',
    seoTitle: 'Produzione di libri ed ebook | Verso Hemelslinn',
    description:
      'Tecniche, strumenti e scelte pratiche per produrre libri cartacei ed ebook accessibili, leggibili e curati nei formati digitali e fisici.',
    intro:
      'Produrre un libro non significa soltanto esportare un file. Significa progettare struttura, leggibilità, accessibilità, formati, metadati e supporti in modo che il testo possa arrivare davvero alle persone che lo leggeranno.',
    sections: [
      {
        title: 'Ebook leggibili e accessibili',
        text:
          'Un ebook ben costruito deve funzionare su dispositivi diversi, rispettare la struttura del testo e restare leggibile anche con strumenti assistivi.',
        roadmap: [
          {
            title: 'Leggere un ebook senza vederlo',
            completed: true,
            articleTitle: 'Un ebook si può leggere anche senza vederlo',
            href: '/articoli/ebook-accessibili-ciechi-ipovedenti/',
          },
          {
            title: 'Leggere ebook su PC, Mac e Linux',
            completed: true,
            articleTitle: 'Come leggere ebook su PC, Mac e Linux',
            href: '/articoli/leggere-ebook-su-pc/',
          },
          'Struttura semantica di un EPUB',
          'Testi alternativi, lingue e navigazione interna',
        ],
      },
      {
        title: 'Dal file digitale al libro stampato',
        text:
          'La produzione cartacea richiede decisioni su formato, margini, copertina, interni, prove di stampa e controlli finali.',
        roadmap: [
          'Preparare un interno per la stampa',
          'Scegliere formato, carta e margini',
          'Controllare copertina e dorso',
          'Prove fisiche e correzioni prima della pubblicazione',
        ],
      },
      {
        title: 'Qualità editoriale e distribuzione',
        text:
          'Un libro deve essere coerente nei dati, nei file e nei punti di accesso: metadati, formati, canali e descrizioni fanno parte del lavoro editoriale.',
        roadmap: [
          'Metadati essenziali di un libro',
          'Differenze tra EPUB, PDF e formati Kindle',
          'Controlli tecnici prima della distribuzione',
          'Archiviare versioni, sorgenti e file finali',
        ],
      },
    ],
    articleSlugs: ['ebook-accessibili-ciechi-ipovedenti', 'leggere-ebook-su-pc'],
    related: ['scrittura-creativa', 'worldbuilding', 'personaggi'],
  },
];

export function getPillarPageBySlug(slug) {
  return pillarPages.find((page) => page.slug === slug);
}

export default pillarPages;
